@if(vatRateFormReady()) {
    <form autocomplete="off" [formGroup]="vatRateForm"
            class="form tw-p-5 tw-flex tw-flex-col tw-gap-5">
        <section class="tw-px-4 tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3 tw-items-center">
            <mat-form-field class="tw-col-span-12 md:tw-col-span-6">
                <mat-label translate>ITEMS.VAT_RATE.VALUE</mat-label>
                <input matInput type="number" formControlName="value" step=".001"
                    [min]="vatRateFormService.validators.valueMinValue">
                @if(vatRateFormService.value?.hasError('min')) {
                    <mat-error>{{'NG_MESSAGES.NUMBER_NOT_VALID' | translate}}</mat-error>
                } @else if(vatRateFormService.value?.hasError('required')) {
                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                }
            </mat-form-field>
            <mat-form-field class="tw-col-span-12 md:tw-col-span-6">
                <mat-label translate>ITEMS.VAT_RATE.CODE</mat-label>
                <mat-select formControlName="code">
                    @for(val of vatCodeList; track $index) {
                        <mat-option [value]="val.value">{{ val.name | translate }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </section>
    </form>
}